// need to rewrite and refactor in future, now simple move all content that drawer has before lockers story to switch/case content by workflow
// file created in story RD-2905 and shoul be rewrited
import { Stack, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';

import { Container, Piece, PieceType, Workflow } from '@apiContract';
import StorageGroup from 'src/components/StorageGroup';

import { sxSection } from '../styles';
import { LocationState, LocationStateChange } from '../useLocationId';

type Props = {
  piece: Piece;
  setIsLoading: (isLoading: boolean) => void;
  isLoadingContainer: boolean;
  onChange: (spot: LocationStateChange) => void;
  spot: LocationState;
  workflow: Workflow;
};

const NotLockersContent: FC<Props> = ({ workflow, spot, piece, setIsLoading, isLoadingContainer, onChange }) => {
  const { pieceLocation } = piece;
  const [foundContainer, setFoundContainer] = useState<Container | undefined>();
  const allCount = foundContainer?.allCount ?? pieceLocation?.container?.allCount;

  return (
    <>
      <Stack sx={sxSection} spacing={3}>
        <Stack direction="row" spacing={0.8}>
          <Typography variant="subtitle1">Storage Group</Typography>
          <Typography variant="body1" color="text.secondary">
            ({allCount} item{allCount === 1 ? '' : 's'})
          </Typography>
        </Stack>
        <StorageGroup
          workflow={workflow}
          piece={piece}
          direction="column"
          onChange={(storageGroupData) =>
            onChange({
              storageGroupData,
              itemSpot: spot.itemSpot,
            })
          }
          isNextOrderNo
          onLoading={setIsLoading}
          isLoading={isLoadingContainer}
          onContainerFound={setFoundContainer}
        />
      </Stack>
      {spot.itemType === PieceType.Package && (
        <Stack sx={sxSection} spacing={3}>
          <Typography variant="subtitle1">Item</Typography>
          <TextField
            value={spot.itemSpot}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChange({
                storageGroupData: spot.storageGroupData,
                itemSpot: event.target.value,
              })
            }
            fullWidth
            label="Spot"
          />
        </Stack>
      )}
    </>
  );
};

export default NotLockersContent;
